module.exports = __webpack_public_path__ + "EXAMPLE-Players-TrainingCentre2.png?17ce2a683e7d5ef3ad158c2d6b58d43b";


//////////////////
// WEBPACK FOOTER
// ./static/EXAMPLE-Players-TrainingCentre2.png
// module id = 348
// module chunks = 0